import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
import Mixin from './mixins'
Vue.mixin(Mixin);

// svg
import '@/icons'
// iconfont
import '@/icons/iconfont/iconfont.css'

import '@/styles/index.scss' // global css

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
